module.exports = __webpack_public_path__ + "static/img/011.17d53bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/011.jpg
// module id = 4Nvz
// module chunks = 0